import Paper from "@mui/material/Paper";
import { useFormContext } from "react-hook-form";
import { SchemaField, type FieldConfig } from "../../../components/forms/SchemaField";
import { FormSection } from "../../../components/forms/FormSection";
import { useIsPhone } from "../../../hooks/useIsPhone";
import type { UserEditFormData } from "../../../schemas/userProfileSchema";

const CONTACT_FIELDS: FieldConfig<UserEditFormData>[] = [
  { name: "phone", label: "Phone", type: "text" },
  { name: "workCity", label: "Work City", type: "text" },
  { name: "workState", label: "Work State / Region", type: "text" },
  {
    name: "linkedIn",
    label: "LinkedIn",
    type: "text",
    placeholder: "https://linkedin.com/in/...",
  },
  {
    name: "website",
    label: "Website",
    type: "text",
    placeholder: "https://...",
  },
];

const LOGISTICS_FIELDS: FieldConfig<UserEditFormData>[] = [
  {
    name: "accessibilityNeeds",
    label: "Accessibility Needs",
    type: "textarea",
    rows: 2,
  },
];

/**
 * Pure section component. Reads/writes through the page-level RHF context.
 */
export function ContactLogisticsTab() {
  const isPhone = useIsPhone();
  const { control } = useFormContext<UserEditFormData>();

  return (
    <Paper sx={{ p: isPhone ? 2 : 3 }}>
      <FormSection title="Contact">
        {CONTACT_FIELDS.map((field) => (
          <SchemaField key={field.name} config={field} control={control} />
        ))}
      </FormSection>

      <FormSection title="Logistics">
        {LOGISTICS_FIELDS.map((field) => (
          <SchemaField key={field.name} config={field} control={control} />
        ))}
      </FormSection>
    </Paper>
  );
}
